import {
  LOGIN_SESSION_EXPIRATION_KEY,
  TOKEN_EXPIRATION_KEY,
} from '@components/views/login/constants';
import {
  getSafeLocalStorageItem,
  setSafeLocalStorageItem,
} from '@utils/localStorage/getSafeLocalStorage';

export const saveExpirationToken = () => {
  const tokenExpirationDate = new Date(new Date().getTime() + 1000 * 60 * 60);

  setSafeLocalStorageItem(
    TOKEN_EXPIRATION_KEY,
    tokenExpirationDate.toISOString()
  );
  return tokenExpirationDate;
};

export const getExpirationTokenDate = () => {
  const tokenExpiration = getSafeLocalStorageItem(TOKEN_EXPIRATION_KEY) || '';
  return {
    tokenExpiration,
    tokenExpirationDate: new Date(tokenExpiration),
  };
};

export const saveLoginSessionExpirationDate = () => {
  const now = new Date();
  const loginSessionExpirationDate = new Date(
    now.getTime() + 5 * 24 * 60 * 60 * 1000
  );

  setSafeLocalStorageItem(
    LOGIN_SESSION_EXPIRATION_KEY,
    loginSessionExpirationDate.toISOString()
  );
  return loginSessionExpirationDate;
};

export const getLoginSessionExpirationDate = () => {
  const loginSessionExpiration =
    getSafeLocalStorageItem(LOGIN_SESSION_EXPIRATION_KEY) || '';
  return {
    loginSessionExpiration,
    loginSessionExpirationDate: new Date(loginSessionExpiration),
  };
};
